import { createContext } from 'react';
import { IUserProfile } from '../types/User/IUserProfile';

export type RevUserContextType = {
    profile: IUserProfile | null;
    headerText: string;
    setHeaderText: (text: string) => void;
    setBackgroundLocation: (location: Location) => void;
    backgroundLocation: Location | null;
}
export const RevUserContext = createContext<RevUserContextType>(null);